import Form from './Modal'

export default Form